import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { id: "user-profile-table-description" }, [
  /*#__PURE__*/_createElementVNode("small", null, "User profile info")
], -1)
const _hoisted_2 = {
  class: "table table-sm table-borderless",
  "aria-describedby": "user-profile-table-description"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("th", { scope: "row" }, "Email", -1)

import AppComponentHeader from "@/components/app/AppComponentHeader.vue";
import { computed, inject, onBeforeMount, ref } from "vue";
import { useStore } from "vuex";
import FormKitSubmitButtonContent from "@/components/app/FormKit/FormKitSubmitButtonContent.vue";
import { userProfilesApi } from "@/di/api";
import { notifyInjectionKey } from "@/keys";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserProfileForm',
  setup(__props) {


const TIMEZONES = ['Europe/Kiev', 'UTC', 'Europe/Moscow']

const store = useStore()
const notify = inject(notifyInjectionKey)

const model = ref<{ name: string, timezone: string }>({ name: '', timezone: '' })
const lock = ref<{ userInfoSubmitting: boolean }>({ userInfoSubmitting: false })

const userProfile = computed(() => store.getters["auth/userProfile"])

const timezones = computed((): { [key: string]: string } => {
  const result: { [key: string]: string } = {}

  TIMEZONES.forEach(tz => {
    result[tz] = tz
  })

  return result
})

function setupModelFromStore () {
  model.value.name = store.getters["auth/userProfile"].name
  model.value.timezone = store.getters["auth/userProfile"].timezone
}

async function submit () {
  lock.value.userInfoSubmitting = true

  try {
    await userProfilesApi.updateUserInfo(store.getters["auth/userProfile"].id, {
      name: model.value.name,
      timezone: model.value.timezone
    })

    await store.dispatch('auth/loadCurrentUserProfile')
    setupModelFromStore()

    notify?.({text: 'User profile updated'})
  } finally {
    lock.value.userInfoSubmitting = false
  }
}

onBeforeMount(() => {
  setupModelFromStore()
})

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppComponentHeader, null, {
      default: _withCtx(() => [
        _createTextVNode("User profile")
      ]),
      _: 1
    }),
    _hoisted_1,
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("tbody", null, [
        (_unref(userProfile)?.extra.email)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("td", null, _toDisplayString(_unref(userProfile)?.extra.email), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_FormKit, {
      modelValue: model.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
      type: "form",
      actions: false,
      onSubmit: submit
    }, {
      default: _withCtx(() => [
        _createVNode(_component_FormKit, {
          name: "name",
          type: "text",
          label: "Name",
          validation: "required",
          "outer-class": "mb-3"
        }),
        _createVNode(_component_FormKit, {
          name: "timezone",
          type: "select",
          label: "Timezone",
          options: _unref(timezones),
          validation: "required",
          "outer-class": "mb-3"
        }, null, 8, ["options"]),
        _createVNode(_component_FormKit, {
          type: "submit",
          disabled: lock.value.userInfoSubmitting,
          "input-class": "btn btn-primary btn-sm"
        }, {
          default: _withCtx(() => [
            _createVNode(FormKitSubmitButtonContent, null, {
              default: _withCtx(() => [
                _createTextVNode("Save")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})